(function () {
  const tagPrefixes = {
    "phone-country-code": "Code_",
    phone: "Phone_",
    birth_month: "WVBirthMonth_",
    skin_type: "SkinType_",
    skin_concern: "SkinConcern_",
    age_group: "Age_",
  };

  // function phoneCheck(form) {
  //   const regexPhoneHK = new RegExp("^[2356789]{1}([0-9]{7})$");
  //   const phoneField = form.querySelector("[name=phone]");
  //   const isValidateMobile = regexPhoneHK.test(phoneField.value);
  //   phoneField.setCustomValidity(
  //     isValidateMobile ? "" : window.translation.registerErrors.phoneFmt;
  //   );
  //   if (!isValidateMobile) {
  //     phoneField.dispatchEvent(new CustomEvent("invalid"));
  //   }
  //   return isValidateMobile;
  // }

  function extraChecks(form) {
    // return phoneCheck(form);
  }

  function findPreviousSibling(elm, selector) {
    let sibling = elm.previousElementSibling;
    while (sibling) {
      if (sibling.matches(selector)) return sibling;
      sibling = sibling.previousElementSibling;
    }
  }

  function getFieldname(elm) {
    const selector = "label";
    const sib = findPreviousSibling(elm, selector);
    return sib ? sib.textContent : "";
  }

  /*  */
  let safeForm = false;
  const form = document.getElementById("create_customer");
  const inputs = form.querySelectorAll("input, select, textarea");
  inputs.forEach((input) => {
    input.addEventListener(
      "invalid",
      () => {
        input.classList.add("error");
        input.addEventListener(
          "change",
          () => {
            input.classList.remove("error");
            input.setCustomValidity("");
          },
          { once: true }
        );
      },
      false
    );
  });
  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }

  form.addEventListener("submit", (e) => {
    if (safeForm) {
      return true;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const errors = [];

    let isValid = form.checkValidity();
    isValid = isValid || extraChecks(form);

    form.querySelectorAll(":invalid").forEach((elm) => {
      let fieldName = getFieldname(elm);
      const requiredErr = htmlDecode(
        window.translation.registerErrors.required
      );
      const fmtErr = htmlDecode(window.translation.registerErrors.invalidFmt);
      let err;
      if (elm.matches("[required]") && !elm.value) {
        err = requiredErr.replace(
          "{{ field_name }}",
          fieldName
        );
      } else {
        err = fmtErr.replace(
          "{{ field_name }}",
          fieldName
        );
      }
      errors.push(err);
    });

    if (!isValid) {
      let errorDiv = form.querySelector(".errors");
      if (errorDiv) {
        errorDiv.innerHTML = "";
      } else {
        errorDiv = document.createElement("div");
      }
      errorDiv.classList.add("errors");
      const errorUl = document.createElement("ul");
      if (errors.length > 0) {
        errorUl.append(
          ...errors.map((err) => {
            const errorLi = document.createElement("li");
            errorLi.textContent = err;
            return errorLi;
          })
        );
        errorDiv.appendChild(errorUl);
      }
      form.prepend(errorDiv);
      errorDiv.scrollIntoView({ block: "center" });
      return false;
    }

    const tagList = Object.entries(tagPrefixes)
      .map(([key, prefix]) => {
        const value = form.querySelector(`[name="${key}"]`).value;
        if (value) {
          return `${prefix}${value}`;
        } else {
          return "";
        }
      })
      .filter((i) => i);
    let customerTagField = form.querySelector('[name="customer[tags]"]');
    if (!customerTagField) {
      customerTagField = document.createElement("input");
      customerTagField.name = "customer[tags]";
      customerTagField.type = "hidden";
    }
    customerTagField.value = tagList.join(",");

    const marketing = form.querySelector(
      '[name="customer[accepts_marketing]"]'
    );
    const compatElm = document.createElement("input");
    compatElm.setAttribute("check", "check");
    compatElm.name = "customer[accepts_marketing]";
    compatElm.type = "hidden";
    compatElm.value = marketing.checked;
    marketing.setAttribute("disabled", "disabled");
    form.append(compatElm);

    safeForm = true;
    form.dispatchEvent(new Event("submit"));
    safeForm = false;
  });
})();
